import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { opacify } from 'polished';
var BLUE = {
  '50': 'hsl(228, 80%, 99%)',
  '100': 'hsl(228, 80%, 98%)',
  '200': 'hsl(228, 80%, 95%)',
  '300': 'hsl(228, 80%, 85%)',
  '400': 'hsl(228, 80%, 75%)',
  '500': 'hsl(228, 80%, 60%)',
  '600': 'hsl(228, 80%, 45%)',
  '700': 'hsl(228, 80%, 35%)',
  '800': 'hsl(228, 80%, 25%)',
  '900': 'hsl(228, 80%, 15%)'
};
export default {
  /**
   * BASE BASE TOKENS
   */
  palette: {
    brand: BLUE,
    white: 'hsl(0, 0%, 100%)',
    black: 'hsl(0, 0%, 0%)',
    blue: BLUE,
    grey: {
      '50': 'hsl(228, 10%, 99%)',
      '100': 'hsl(228, 10%, 98%)',
      '200': 'hsl(228, 10%, 95%)',
      '300': 'hsl(228, 10%, 85%)',
      '400': 'hsl(228, 10%, 75%)',
      '500': 'hsl(228, 10%, 60%)',
      '600': 'hsl(228, 10%, 45%)',
      '700': 'hsl(228, 10%, 35%)',
      '800': 'hsl(228, 10%, 25%)',
      '900': 'hsl(228, 10%, 15%)'
    },
    neutral: {
      '50': 'hsl(0, 0%, 99%)',
      '100': 'hsl(0, 0%, 98%)',
      '200': 'hsl(0, 0%, 95%)',
      '300': 'hsl(0, 0%, 85%)',
      '400': 'hsl(0, 0%, 75%)',
      '500': 'hsl(0, 0%, 60%)',
      '600': 'hsl(0, 0%, 45%)',
      '700': 'hsl(0, 0%, 35%)',
      '800': 'hsl(0, 0%, 25%)',
      '900': 'hsl(0, 0%, 15%)'
    },
    green: {
      '50': 'hsl(140, 57%, 99%)',
      '100': 'hsl(140, 57%, 98%)',
      '200': 'hsl(140, 57%, 95%)',
      '300': 'hsl(140, 57%, 85%)',
      '400': 'hsl(140, 57%, 75%)',
      '500': 'hsl(140, 57%, 60%)',
      '600': 'hsl(140, 57%, 45%)',
      '700': 'hsl(140, 57%, 35%)',
      '800': 'hsl(140, 57%, 25%)',
      '900': 'hsl(140, 57%, 15%)'
    },
    yellow: {
      '50': 'hsl(40, 100%, 99%)',
      '100': 'hsl(40, 100%, 98%)',
      '200': 'hsl(40, 100%, 95%)',
      '300': 'hsl(40, 100%, 85%)',
      '400': 'hsl(40, 100%, 75%)',
      '500': 'hsl(40, 100%, 60%)',
      '600': 'hsl(40, 100%, 45%)',
      '700': 'hsl(40, 100%, 35%)',
      '800': 'hsl(40, 100%, 25%)',
      '900': 'hsl(40, 100%, 15%)'
    },
    red: {
      '50': 'hsl(360, 82%, 99%)',
      '100': 'hsl(360, 82%, 98%)',
      '200': 'hsl(360, 82%, 95%)',
      '300': 'hsl(360, 82%, 85%)',
      '400': 'hsl(360, 82%, 75%)',
      '500': 'hsl(360, 82%, 60%)',
      '600': 'hsl(360, 82%, 45%)',
      '700': 'hsl(360, 82%, 35%)',
      '800': 'hsl(360, 82%, 25%)',
      '900': 'hsl(360, 82%, 15%)'
    },
    tint: {
      light: {
        '50': 'hsla(0, 0%, 100%, 0.05)',
        '100': 'hsla(0, 0%, 100%, 0.1)',
        '200': 'hsla(0, 0%, 100%, 0.2)',
        '300': 'hsla(0, 0%, 100%, 0.3',
        '400': 'hsla(0, 0%, 100%, 0.4)',
        '500': 'hsla(0, 0%, 100%, 0.5)',
        '600': 'hsla(0, 0%, 100%, 0.6)',
        '700': 'hsla(0, 0%, 100%, 0.7)',
        '800': 'hsla(0, 0%, 100%, 0.8)',
        '900': 'hsla(0, 0%, 100%, 0.9)'
      }
    },
    shade: {
      dark: {
        '50': 'hsla(0, 0%, 0%, 0.05)',
        '100': 'hsla(0, 0%, 0%, 0.1)',
        '200': 'hsla(0, 0%, 0%, 0.2)',
        '300': 'hsla(0, 0%, 0%, 0.3)',
        '400': 'hsla(0, 0%, 0%, 0.4)',
        '500': 'hsla(0, 0%, 0%, 0.5)',
        '600': 'hsla(0, 0%, 0%, 0.6)',
        '700': 'hsla(0, 0%, 0%, 0.7)',
        '800': 'hsla(0, 0%, 0%, 0.8)',
        '900': 'hsla(0, 0%, 0%, 0.9)'
      },
      primary: {
        '50': 'hsla(228, 80%, 60%, 0.05)',
        '100': 'hsla(228, 80%, 60%, 0.1)',
        '200': 'hsla(228, 80%, 60%, 0.2)',
        '300': 'hsla(228, 80%, 60%, 0.3)',
        '400': 'hsla(228, 80%, 60%, 0.4)',
        '500': 'hsla(228, 80%, 60%, 0.5)',
        '600': 'hsla(228, 80%, 60%, 0.6)',
        '700': 'hsla(228, 80%, 60%, 0.7)',
        '800': 'hsla(228, 80%, 60%, 0.8)',
        '900': 'hsla(228, 80%, 60%, 0.9)'
      }
    }
  },
  color: {
    textStyle: {
      body: {
        default: function _default(_ref) {
          var token = _ref.token;
          return token('palette.grey.900');
        },
        contrast: function contrast(_ref2) {
          var token = _ref2.token;
          return token('palette.brand.50');
        },
        subtext: function subtext(_ref3) {
          var token = _ref3.token;
          return token('palette.grey.600');
        },
        hint: function hint(_ref4) {
          var token = _ref4.token;
          return token('palette.grey.500');
        },
        error: function error(_ref5) {
          var token = _ref5.token;
          return token('palette.red.600');
        },
        disabled: function disabled(_ref6) {
          var token = _ref6.token;
          return token('palette.grey.400');
        }
      },
      primary: {
        default: function _default(_ref7) {
          var token = _ref7.token;
          return token('palette.brand.500');
        },
        contrast: function contrast(_ref8) {
          var token = _ref8.token;
          return token('palette.brand.50');
        }
      },
      secondary: {
        default: function _default(_ref9) {
          var token = _ref9.token;
          return token('palette.brand.100');
        },
        contrast: function contrast(_ref10) {
          var token = _ref10.token;
          return token('palette.brand.800');
        }
      },
      information: {
        default: function _default(_ref11) {
          var token = _ref11.token;
          return token('palette.brand.900');
        },
        contrast: function contrast(_ref12) {
          var token = _ref12.token;
          return token('palette.brand.50');
        }
      },
      success: {
        default: function _default(_ref13) {
          var token = _ref13.token;
          return token('palette.green.900');
        },
        contrast: function contrast(_ref14) {
          var token = _ref14.token;
          return token('palette.green.50');
        }
      },
      warning: {
        default: function _default(_ref15) {
          var token = _ref15.token;
          return token('palette.yellow.900');
        },
        contrast: function contrast(_ref16) {
          var token = _ref16.token;
          return token('palette.yellow.50');
        }
      },
      danger: {
        default: function _default(_ref17) {
          var token = _ref17.token;
          return token('palette.red.900');
        },
        contrast: function contrast(_ref18) {
          var token = _ref18.token;
          return token('palette.red.50');
        }
      },
      link: {
        idle: {
          default: function _default(_ref19) {
            var token = _ref19.token;
            return token('palette.brand.500');
          },
          contrast: function contrast(_ref20) {
            var token = _ref20.token;
            return token('palette.brand.50');
          }
        },
        hover: {
          default: function _default(_ref21) {
            var token = _ref21.token;
            return token('palette.brand.600');
          },
          contrast: function contrast(_ref22) {
            var token = _ref22.token;
            return token('palette.brand.100');
          }
        }
      }
    },
    primary: {
      idle: {
        default: function _default(_ref23) {
          var token = _ref23.token;
          return token('palette.brand.500');
        },
        contrast: function contrast(_ref24) {
          var token = _ref24.token;
          return token('palette.brand.50');
        }
      },
      hover: {
        default: function _default(_ref25) {
          var token = _ref25.token;
          return token('palette.brand.600');
        },
        contrast: function contrast(_ref26) {
          var token = _ref26.token;
          return token('palette.brand.50');
        }
      },
      active: {
        default: function _default(_ref27) {
          var token = _ref27.token;
          return token('palette.brand.700');
        },
        contrast: function contrast(_ref28) {
          var token = _ref28.token;
          return token('palette.brand.50');
        }
      }
    },
    secondary: {
      idle: {
        default: function _default(_ref29) {
          var token = _ref29.token;
          return token('palette.brand.100');
        },
        contrast: function contrast(_ref30) {
          var token = _ref30.token;
          return token('palette.brand.800');
        }
      },
      hover: {
        default: function _default(_ref31) {
          var token = _ref31.token;
          return token('palette.brand.200');
        },
        contrast: function contrast(_ref32) {
          var token = _ref32.token;
          return token('palette.brand.800');
        }
      },
      active: {
        default: function _default(_ref33) {
          var token = _ref33.token;
          return token('palette.brand.300');
        },
        contrast: function contrast(_ref34) {
          var token = _ref34.token;
          return token('palette.brand.800');
        }
      }
    },
    information: {
      idle: {
        default: function _default(_ref35) {
          var token = _ref35.token;
          return token('palette.blue.500');
        },
        contrast: function contrast(_ref36) {
          var token = _ref36.token;
          return token('palette.blue.50');
        }
      },
      hover: {
        default: function _default(_ref37) {
          var token = _ref37.token;
          return token('palette.blue.600');
        },
        contrast: function contrast(_ref38) {
          var token = _ref38.token;
          return token('palette.blue.50');
        }
      },
      active: {
        default: function _default(_ref39) {
          var token = _ref39.token;
          return token('palette.blue.700');
        },
        contrast: function contrast(_ref40) {
          var token = _ref40.token;
          return token('palette.blue.50');
        }
      }
    },
    success: {
      idle: {
        default: function _default(_ref41) {
          var token = _ref41.token;
          return token('palette.green.700');
        },
        contrast: function contrast(_ref42) {
          var token = _ref42.token;
          return token('palette.green.50');
        }
      },
      hover: {
        default: function _default(_ref43) {
          var token = _ref43.token;
          return token('palette.green.800');
        },
        contrast: function contrast(_ref44) {
          var token = _ref44.token;
          return token('palette.green.50');
        }
      },
      active: {
        default: function _default(_ref45) {
          var token = _ref45.token;
          return token('palette.green.900');
        },
        contrast: function contrast(_ref46) {
          var token = _ref46.token;
          return token('palette.green.50');
        }
      }
    },
    warning: {
      idle: {
        default: function _default(_ref47) {
          var token = _ref47.token;
          return token('palette.yellow.600');
        },
        contrast: function contrast(_ref48) {
          var token = _ref48.token;
          return token('palette.yellow.50');
        }
      },
      hover: {
        default: function _default(_ref49) {
          var token = _ref49.token;
          return token('palette.yellow.700');
        },
        contrast: function contrast(_ref50) {
          var token = _ref50.token;
          return token('palette.yellow.50');
        }
      },
      active: {
        default: function _default(_ref51) {
          var token = _ref51.token;
          return token('palette.yellow.800');
        },
        contrast: function contrast(_ref52) {
          var token = _ref52.token;
          return token('palette.yellow.50');
        }
      }
    },
    danger: {
      idle: {
        default: function _default(_ref53) {
          var token = _ref53.token;
          return token('palette.red.700');
        },
        contrast: function contrast(_ref54) {
          var token = _ref54.token;
          return token('palette.red.50');
        }
      },
      hover: {
        default: function _default(_ref55) {
          var token = _ref55.token;
          return token('palette.red.800');
        },
        contrast: function contrast(_ref56) {
          var token = _ref56.token;
          return token('palette.red.50');
        }
      },
      active: {
        default: function _default(_ref57) {
          var token = _ref57.token;
          return token('palette.red.900');
        },
        contrast: function contrast(_ref58) {
          var token = _ref58.token;
          return token('palette.red.50');
        }
      }
    },
    input: {
      idle: function idle(_ref59) {
        var token = _ref59.token;
        return token('palette.white');
      },
      active: function active(_ref60) {
        var token = _ref60.token;
        return token('palette.brand.600');
      },
      selected: function selected(_ref61) {
        var token = _ref61.token;
        return token('palette.brand.600');
      },
      error: function error(_ref62) {
        var token = _ref62.token;
        return token('palette.red.600');
      },
      disabled: {
        default: function _default(_ref63) {
          var token = _ref63.token;
          return token('palette.grey.200');
        },
        dark: function dark(_ref64) {
          var token = _ref64.token;
          return token('palette.grey.400');
        }
      }
    },
    container: {
      interactive: {
        idle: function idle(_ref65) {
          var token = _ref65.token;
          return token('palette.white');
        },
        hover: function hover(_ref66) {
          var token = _ref66.token;
          return token('palette.brand.100');
        },
        selected: function selected(_ref67) {
          var token = _ref67.token;
          return token('palette.brand.600');
        }
      },
      static: {
        default: function _default(_ref68) {
          var token = _ref68.token;
          return token('palette.white');
        },
        contrast: function contrast(_ref69) {
          var token = _ref69.token;
          return token('palette.grey.50');
        },
        dark: function dark(_ref70) {
          var token = _ref70.token;
          return token('palette.brand.900');
        },
        primary: function primary(_ref71) {
          var token = _ref71.token;
          return token('palette.brand.500');
        },
        secondary: function secondary(_ref72) {
          var token = _ref72.token;
          return token('palette.brand.100');
        },
        information: function information(_ref73) {
          var token = _ref73.token;
          return token('palette.brand.100');
        },
        success: function success(_ref74) {
          var token = _ref74.token;
          return token('palette.green.100');
        },
        warning: function warning(_ref75) {
          var token = _ref75.token;
          return token('palette.yellow.100');
        },
        danger: function danger(_ref76) {
          var token = _ref76.token;
          return token('palette.red.100');
        }
      }
    },
    border: {
      input: {
        idle: function idle(_ref77) {
          var token = _ref77.token;
          return token('palette.grey.400');
        },
        hover: function hover(_ref78) {
          var token = _ref78.token;
          return token('palette.brand.300');
        },
        focus: function focus(_ref79) {
          var token = _ref79.token;
          return token('palette.brand.300');
        },
        active: function active(_ref80) {
          var token = _ref80.token;
          return token('palette.brand.600');
        },
        selected: function selected(_ref81) {
          var token = _ref81.token;
          return token('palette.brand.600');
        },
        error: function error(_ref82) {
          var token = _ref82.token;
          return token('palette.red.600');
        },
        disabled: function disabled(_ref83) {
          var token = _ref83.token;
          return token('palette.grey.400');
        }
      },
      container: {
        interactive: {
          idle: function idle(_ref84) {
            var token = _ref84.token;
            return token('palette.grey.200');
          },
          hover: function hover(_ref85) {
            var token = _ref85.token;
            return token('palette.brand.300');
          }
        },
        static: {
          light: function light(_ref86) {
            var token = _ref86.token;
            return token('palette.grey.200');
          },
          medium: function medium(_ref87) {
            var token = _ref87.token;
            return token('palette.grey.400');
          },
          dark: function dark(_ref88) {
            var token = _ref88.token;
            return token('palette.grey.600');
          },
          contrast: function contrast(_ref89) {
            var token = _ref89.token;
            return token('palette.brand.50');
          }
        }
      },
      primary: {
        idle: {
          default: function _default(_ref90) {
            var token = _ref90.token;
            return token('palette.brand.500');
          },
          contrast: function contrast(_ref91) {
            var token = _ref91.token;
            return token('palette.brand.50');
          }
        },
        hover: {
          default: function _default(_ref92) {
            var token = _ref92.token;
            return token('palette.brand.600');
          },
          contrast: function contrast(_ref93) {
            var token = _ref93.token;
            return token('palette.brand.50');
          }
        },
        active: {
          default: function _default(_ref94) {
            var token = _ref94.token;
            return token('palette.brand.700');
          },
          contrast: function contrast(_ref95) {
            var token = _ref95.token;
            return token('palette.brand.50');
          }
        }
      },
      secondary: {
        idle: {
          default: function _default(_ref96) {
            var token = _ref96.token;
            return token('palette.brand.300');
          },
          contrast: function contrast(_ref97) {
            var token = _ref97.token;
            return token('palette.brand.800');
          }
        },
        hover: {
          default: function _default(_ref98) {
            var token = _ref98.token;
            return token('palette.brand.400');
          },
          contrast: function contrast(_ref99) {
            var token = _ref99.token;
            return token('palette.brand.900');
          }
        },
        active: {
          default: function _default(_ref100) {
            var token = _ref100.token;
            return token('palette.brand.400');
          },
          contrast: function contrast(_ref101) {
            var token = _ref101.token;
            return token('palette.brand.900');
          }
        }
      },
      information: {
        idle: {
          default: function _default(_ref102) {
            var token = _ref102.token;
            return token('palette.blue.500');
          },
          contrast: function contrast(_ref103) {
            var token = _ref103.token;
            return token('palette.blue.50');
          }
        },
        hover: {
          default: function _default(_ref104) {
            var token = _ref104.token;
            return token('palette.blue.600');
          },
          contrast: function contrast(_ref105) {
            var token = _ref105.token;
            return token('palette.blue.100');
          }
        },
        active: {
          default: function _default(_ref106) {
            var token = _ref106.token;
            return token('palette.blue.700');
          },
          contrast: function contrast(_ref107) {
            var token = _ref107.token;
            return token('palette.blue.200');
          }
        }
      },
      success: {
        idle: {
          default: function _default(_ref108) {
            var token = _ref108.token;
            return token('palette.green.700');
          },
          contrast: function contrast(_ref109) {
            var token = _ref109.token;
            return token('palette.green.50');
          }
        },
        hover: {
          default: function _default(_ref110) {
            var token = _ref110.token;
            return token('palette.green.800');
          },
          contrast: function contrast(_ref111) {
            var token = _ref111.token;
            return token('palette.green.100');
          }
        },
        active: {
          default: function _default(_ref112) {
            var token = _ref112.token;
            return token('palette.green.900');
          },
          contrast: function contrast(_ref113) {
            var token = _ref113.token;
            return token('palette.green.200');
          }
        }
      },
      warning: {
        idle: {
          default: function _default(_ref114) {
            var token = _ref114.token;
            return token('palette.yellow.600');
          },
          contrast: function contrast(_ref115) {
            var token = _ref115.token;
            return token('palette.yellow.50');
          }
        },
        hover: {
          default: function _default(_ref116) {
            var token = _ref116.token;
            return token('palette.yellow.700');
          },
          contrast: function contrast(_ref117) {
            var token = _ref117.token;
            return token('palette.yellow.100');
          }
        },
        active: {
          default: function _default(_ref118) {
            var token = _ref118.token;
            return token('palette.yellow.800');
          },
          contrast: function contrast(_ref119) {
            var token = _ref119.token;
            return token('palette.yellow.200');
          }
        }
      },
      danger: {
        idle: {
          default: function _default(_ref120) {
            var token = _ref120.token;
            return token('palette.red.700');
          },
          contrast: function contrast(_ref121) {
            var token = _ref121.token;
            return token('palette.red.50');
          }
        },
        hover: {
          default: function _default(_ref122) {
            var token = _ref122.token;
            return token('palette.red.800');
          },
          contrast: function contrast(_ref123) {
            var token = _ref123.token;
            return token('palette.red.100');
          }
        },
        active: {
          default: function _default(_ref124) {
            var token = _ref124.token;
            return token('palette.red.900');
          },
          contrast: function contrast(_ref125) {
            var token = _ref125.token;
            return token('palette.red.200');
          }
        }
      }
    },
    pageBackground: {
      default: function _default(_ref126) {
        var token = _ref126.token;
        return token('palette.grey.50');
      },
      alternate: function alternate(_ref127) {
        var token = _ref127.token;
        return token('palette.white');
      }
    },
    overlayOpacity: {
      default: function _default(_ref128) {
        var token = _ref128.token;
        return token('palette.shade.dark.800');
      }
    }
  },
  border: {
    width: {
      none: '0rem',
      thin: '.1rem',
      medium: '.2rem',
      thick: '.4rem'
    },
    radius: {
      none: '0rem',
      small: '.2rem',
      medium: '.4rem',
      large: '1.6rem',
      circle: '100%'
    }
  },
  shadow: {
    heavy: function heavy(_ref129) {
      var token = _ref129.token;
      return "0 1.6rem 3.2rem ".concat(opacify(-0.92, token('palette.grey.900')), ", ") + "0 .8rem 1.6rem ".concat(opacify(-0.84, token('palette.grey.900')));
    },
    medium: function medium(_ref130) {
      var token = _ref130.token;
      return "0 .8rem 1.6rem ".concat(opacify(-0.84, token('palette.grey.900')), ", ") + "0 .4rem 1.2rem ".concat(opacify(-0.88, token('palette.grey.900')));
    },
    light: function light(_ref131) {
      var token = _ref131.token;
      return "0 .4rem .8rem ".concat(opacify(-0.92, token('palette.grey.900')), ", ") + "0 .2rem .8rem ".concat(opacify(-0.88, token('palette.grey.900')));
    },
    ultralight: function ultralight(_ref132) {
      var _context;

      var token = _ref132.token;
      return _concatInstanceProperty(_context = "0 .2rem .4rem ".concat(opacify(-0.92, token('palette.grey.900')), ", 0 .2rem .4rem ")).call(_context, opacify(-0.88, token('palette.grey.900')));
    },
    menu: function menu(_ref133) {
      var token = _ref133.token;
      return "0 0 .2rem ".concat(token('palette.grey.400'), ", ") + "0 .2rem .4rem ".concat(opacify(-0.92, token('palette.brand.500')), ", ") + "0 .2rem .4rem ".concat(opacify(-0.88, token('palette.brand.500')));
    },
    focus: function focus(_ref134) {
      var token = _ref134.token;
      return "0 0 0 0.3rem ".concat(opacify(-0.4, token('color.border.input.focus')));
    },
    innerBorder: {
      horizontalBottom: function horizontalBottom(_ref135) {
        var token = _ref135.token;
        return "inset 0 -.1rem .1rem ".concat(token('palette.grey.200'));
      }
    }
  },
  spacing: {
    none: '0rem',
    xxxs: '.2rem',
    xxs: '.4rem',
    xs: '.8rem',
    s: '1.2rem',
    m: '1.6rem',
    l: '2rem',
    xl: '2.4rem',
    xxl: '3.2rem',
    xxxl: '4rem'
  },
  icon: {
    size: {
      '2xs': '1rem',
      xs: '1.2rem',
      s: '1.6rem',
      m: '2rem',
      l: '2.4rem'
    }
  },
  typography: {
    size: {
      xs: '1rem',
      s: '1.2rem',
      m: '1.4rem',
      l: '1.6rem',
      xl: '1.8rem',
      xxl: '2rem',
      '3xl': '2.4rem',
      '4xl': '3.2rem'
    },
    weight: {
      thin: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      heavy: 800,
      black: 900
    },
    family: {
      normal: 'proxima-nova, Proxima Nova, helvetica, arial, sans-serif',
      mono: 'Monaco, monospace'
    },
    lineHeight: {
      xs: '1.2rem',
      s: '1.6rem',
      m: '2rem',
      l: '2.4rem',
      xl: '3.2rem',
      '2xl': '4rem'
    },
    letterSpacing: {
      compact: '-.05rem',
      normal: '0',
      wide: '.05rem'
    }
  },
  textStyle: {
    body: {
      default: {
        font: {
          family: function family(_ref136) {
            var token = _ref136.token;
            return token('typography.family.normal');
          },
          size: function size(_ref137) {
            var token = _ref137.token;
            return token('typography.size.m');
          },
          weight: function weight(_ref138) {
            var token = _ref138.token;
            return token('typography.weight.medium');
          }
        },
        lineHeight: function lineHeight(_ref139) {
          var token = _ref139.token;
          return token('typography.lineHeight.m');
        },
        letterSpacing: function letterSpacing(_ref140) {
          var token = _ref140.token;
          return token('typography.letterSpacing.normal');
        },
        color: function color(_ref141) {
          var token = _ref141.token;
          return token('color.textStyle.body.default');
        }
      },
      contrast: {
        color: function color(_ref142) {
          var token = _ref142.token;
          return token('color.textStyle.body.constrast');
        }
      }
    },
    paragraph: {
      default: {
        font: {
          size: function size(_ref143) {
            var token = _ref143.token;
            return token('typography.size.l');
          },
          weight: function weight(_ref144) {
            var token = _ref144.token;
            return token('typography.weight.medium');
          },
          height: function height(_ref145) {
            var token = _ref145.token;
            return token('typography.lineHeight.l');
          }
        },
        lineHeight: function lineHeight(_ref146) {
          var token = _ref146.token;
          return token('typography.lineHeight.l');
        },
        letterSpacing: function letterSpacing(_ref147) {
          var token = _ref147.token;
          return token('typography.letterSpacing.normal');
        },
        color: function color(_ref148) {
          var token = _ref148.token;
          return token('color.textStyle.body.default');
        },
        padding: {
          top: function top(_ref149) {
            var token = _ref149.token;
            return token('spacing.s');
          },
          bottom: function bottom(_ref150) {
            var token = _ref150.token;
            return token('spacing.s');
          }
        }
      }
    },
    link: {
      default: {
        idle: {
          textDecoration: 'underline',
          color: function color(_ref151) {
            var token = _ref151.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        hover: {
          color: function color(_ref152) {
            var token = _ref152.token;
            return token('color.textStyle.link.hover.default');
          }
        },
        active: {
          color: function color(_ref153) {
            var token = _ref153.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        focused: {
          color: function color(_ref154) {
            var token = _ref154.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        disabled: {
          color: function color(_ref155) {
            var token = _ref155.token;
            return token('color.state.disabled.dark');
          }
        }
      },
      // NOTE: this is horrible for accessibility
      light: {
        idle: {
          textDecoration: 'underline',
          color: function color(_ref156) {
            var token = _ref156.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        hover: {
          color: function color(_ref157) {
            var token = _ref157.token;
            return token('color.textStyle.link.hover.default');
          }
        },
        active: {
          color: function color(_ref158) {
            var token = _ref158.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        focused: {
          color: function color(_ref159) {
            var token = _ref159.token;
            return token('color.textStyle.link.idle.default');
          }
        },
        disabled: {
          color: function color(_ref160) {
            var token = _ref160.token;
            return token('color.state.disabled.light');
          }
        }
      }
    },
    heading: {
      1: {
        font: {
          size: function size(_ref161) {
            var token = _ref161.token;
            return token('typography.size.4xl');
          },
          weight: function weight(_ref162) {
            var token = _ref162.token;
            return token('typography.weight.bold');
          }
        },
        lineHeight: function lineHeight(_ref163) {
          var token = _ref163.token;
          return token('typography.lineHeight.2xl');
        }
      },
      2: {
        font: {
          size: function size(_ref164) {
            var token = _ref164.token;
            return token('typography.size.3xl');
          },
          weight: function weight(_ref165) {
            var token = _ref165.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref166) {
          var token = _ref166.token;
          return token('typography.lineHeight.xl');
        }
      },
      3: {
        font: {
          size: function size(_ref167) {
            var token = _ref167.token;
            return token('typography.size.xxl');
          },
          weight: function weight(_ref168) {
            var token = _ref168.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref169) {
          var token = _ref169.token;
          return token('typography.lineHeight.l');
        }
      },
      4: {
        font: {
          size: function size(_ref170) {
            var token = _ref170.token;
            return token('typography.size.xl');
          },
          weight: function weight(_ref171) {
            var token = _ref171.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref172) {
          var token = _ref172.token;
          return token('typography.lineHeight.l');
        }
      }
    },
    normal: {
      default: {
        font: {
          size: function size(_ref173) {
            var token = _ref173.token;
            return token('typography.size.m');
          },
          weight: function weight(_ref174) {
            var token = _ref174.token;
            return token('typography.weight.medium');
          }
        },
        lineHeight: function lineHeight(_ref175) {
          var token = _ref175.token;
          return token('typography.lineHeight.m');
        }
      },
      semibold: {
        font: {
          size: function size(_ref176) {
            var token = _ref176.token;
            return token('typography.size.m');
          },
          weight: function weight(_ref177) {
            var token = _ref177.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref178) {
          var token = _ref178.token;
          return token('typography.lineHeight.m');
        }
      },
      bold: {
        font: {
          size: function size(_ref179) {
            var token = _ref179.token;
            return token('typography.size.m');
          },
          weight: function weight(_ref180) {
            var token = _ref180.token;
            return token('typography.weight.bold');
          }
        },
        lineHeight: function lineHeight(_ref181) {
          var token = _ref181.token;
          return token('typography.lineHeight.m');
        }
      }
    },
    large: {
      default: {
        font: {
          size: function size(_ref182) {
            var token = _ref182.token;
            return token('typography.size.l');
          },
          weight: function weight(_ref183) {
            var token = _ref183.token;
            return token('typography.weight.medium');
          }
        },
        lineHeight: function lineHeight(_ref184) {
          var token = _ref184.token;
          return token('typography.lineHeight.l');
        }
      },
      semibold: {
        font: {
          size: function size(_ref185) {
            var token = _ref185.token;
            return token('typography.size.l');
          },
          weight: function weight(_ref186) {
            var token = _ref186.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref187) {
          var token = _ref187.token;
          return token('typography.lineHeight.l');
        }
      },
      bold: {
        font: {
          size: function size(_ref188) {
            var token = _ref188.token;
            return token('typography.size.l');
          },
          weight: function weight(_ref189) {
            var token = _ref189.token;
            return token('typography.weight.bold');
          }
        },
        lineHeight: function lineHeight(_ref190) {
          var token = _ref190.token;
          return token('typography.lineHeight.l');
        }
      }
    },
    small: {
      default: {
        font: {
          size: function size(_ref191) {
            var token = _ref191.token;
            return token('typography.size.s');
          },
          weight: function weight(_ref192) {
            var token = _ref192.token;
            return token('typography.weight.medium');
          }
        },
        lineHeight: function lineHeight(_ref193) {
          var token = _ref193.token;
          return token('typography.lineHeight.s');
        }
      },
      semibold: {
        font: {
          size: function size(_ref194) {
            var token = _ref194.token;
            return token('typography.size.s');
          },
          weight: function weight(_ref195) {
            var token = _ref195.token;
            return token('typography.weight.semibold');
          }
        },
        lineHeight: function lineHeight(_ref196) {
          var token = _ref196.token;
          return token('typography.lineHeight.s');
        }
      },
      bold: {
        font: {
          size: function size(_ref197) {
            var token = _ref197.token;
            return token('typography.size.s');
          },
          weight: function weight(_ref198) {
            var token = _ref198.token;
            return token('typography.weight.bold');
          }
        },
        lineHeight: function lineHeight(_ref199) {
          var token = _ref199.token;
          return token('typography.lineHeight.s');
        }
      }
    },
    label: {
      font: {
        size: function size(_ref200) {
          var token = _ref200.token;
          return token('textStyle.small.semibold.font.size');
        },
        weight: function weight(_ref201) {
          var token = _ref201.token;
          return token('textStyle.small.semibold.font.weight');
        }
      },
      lineHeight: function lineHeight(_ref202) {
        var token = _ref202.token;
        return token('textStyle.small.semibold.lineHeight');
      }
    }
  }
};